export const CHATBOT_SCRIPT_ELEMENT_ID = "salesforceEinsteinChatbotSnippet";
export const STORAGE_KEY = "salesforce-chatbot-button-position";
export const DRAG_THRESHOLD = 5;
